import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Linking } from 'react-native';
import { Inline } from '@styleseat/ui';
import Modal from '../../Modal';
import AvatarIcon from '../../AvatarIcon';
import StateLink from '../../StateLink';
import Analytics from '../../../modules/analytics';
import { CALENDAR_ROUTE } from '../../../route-names';
import GlyphIcon, { ENVELOPE, PHONE, SMS } from '../../ui/GlyphIcon';
import { Button } from '../../ui';

import './ClientMessageModal.scss';

/**
 * This modal displays a client message
 */
export default class ClientMessageModal extends React.Component {
  static propTypes = {
    /** The message object */
    message: PropTypes.object.isRequired,

    /** INTERNAL USE -- DO NOT SET (set by modalManager)
     The DOM node the modal was rendered into. */
    renderContainer: PropTypes.object,
  };

  static defaultProps = {
    renderContainer: null,
  };

  modal = null;

  componentDidMount() {
    Analytics.track('pro_message_viewed', {
      message_id: this.props.message.uuid,
    });
  }

  trackReplyIntent(optionName) {
    Analytics.track('pro_message_clicked_reply_option', {
      option_name: optionName,
      message_id: this.props.message.uuid,
    });
  }

  handleBookClicked = () => {
    this.trackReplyIntent('book');
    this.closeModal();
  };

  handleCallPro = message => {
    this.trackReplyIntent('phone_call');
    Linking.openURL(`tel:${message.phone}`);
  };

  handleSmsPro = message => {
    this.trackReplyIntent('sms');
    Linking.openURL(`sms:${message.phone}`);
  };

  handleEmailPro = message => {
    this.trackReplyIntent('email');
    Linking.openURL(`mailto:${message.email}`);
  };

  closeModal = () => {
    if (!this.modal) return;
    this.modal.close();
  };

  render() {
    const { message, renderContainer } = this.props;
    const stateParams = {
      mode: 'week',
      select: true,
      clientId: message.client_id,
    };

    return (
      <Modal
        ref={m => { this.modal = m; }}
        title="Message"
        initialOpen
        transitionOpen="slide-in-up"
        transitionClose="slide-out-down"
        renderContainer={renderContainer}
      >
        <section className="client-message-modal">
          <div className="left-column">
            <AvatarIcon
              icon={message.thumbnail}
              name={message.client_name}
            />
          </div>
          <section className="right-column">
            <section>
              <h2 className="client-name">{message.client_name}</h2>
              <p className="message">{` "${message.message}" `}</p>
              <p className="message-date">
                <span>{`${moment(message.creation_time).format('ddd MMM D')}`}</span>
                <span>&nbsp;&bull;&nbsp;</span>
                <span>{`${moment(message.creation_time).format('h:mm A')}`}</span>
              </p>
            </section>
            <Inline space={16} paddingTop={8}>
              <StateLink
                to={CALENDAR_ROUTE}
                params={stateParams}
                onClick={this.handleBookClicked}
                testID="message_modal_book_btn"
              >
                <Button size="small">Book</Button>
              </StateLink>
              <GlyphIcon
                aria-label="telephone"
                testID="message_modal_phone_call_btn"
                content={PHONE}
                onPress={() => this.handleCallPro(message)}
                style={{ fontSize: 20, paddingRight: 8 }}
              />
              <GlyphIcon
                aria-label="sms"
                testID="message_modal_sms_btn"
                content={SMS}
                onPress={() => this.handleSmsPro(message)}
                style={{ fontSize: 26, paddingRight: 8 }}
              />
              {message.email && (
                <GlyphIcon
                  aria-label="email"
                  testID="message_modal_email_btn"
                  content={ENVELOPE}
                  onPress={() => this.handleEmailPro(message)}
                  style={{ fontSize: 28 }}
                />
              )}
            </Inline>
          </section>
        </section>
      </Modal>
    );
  }
}
